import camelCase from 'lodash/camelCase';
import pick from 'lodash/pick';
import {
  Authorization,
  AuthorizeComponent,
  AuthorizationAPI
} from './Authorization';

export default class AuthorizationStore {
  constructor(rootStore, permission) {
    this.rootStore = rootStore;
    this.authorization = Authorization;
    this.authorizationApi = AuthorizationAPI;
    this.authorizeComponent = AuthorizeComponent;

    // add each permission as a class' property
    if (permission) {
      Object.assign(
        this,
        pick(permission, ['canShow', 'canUpdate', 'canDestroy'])
      );

      // handle custom permission if any.
      // also transform the permission name to camel case
      if (permission.customPermissions) {
        permission.customPermissions.map(custom => {
          Object.assign(this, { [camelCase(custom.name)]: custom.value });
        });
      }
    }
  }

  get authShow() {
    return AuthorizeComponent(this.canShow);
  }

  get authUpdate() {
    return AuthorizeComponent(this.canUpdate);
  }

  get authDestroy() {
    return AuthorizeComponent(this.canDestroy);
  }
}
